/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * Unique identifier for the country
     * @type {string}
     * @memberof Country
     */
    readonly id: string;
    /**
     * 3-character country code
     * @type {string}
     * @memberof Country
     */
    code: string;
    /**
     * Country name
     * @type {string}
     * @memberof Country
     */
    name: string;
    /**
     * URL of the country flag or representative image
     * @type {string}
     * @memberof Country
     */
    imageUrl?: string;
    /**
     * Timestamp when the country was created
     * @type {Date}
     * @memberof Country
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the country was last updated
     * @type {Date}
     * @memberof Country
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Country interface.
 */
export function instanceOfCountry(value: object): value is Country {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CountryFromJSON(json: any): Country {
    return CountryFromJSONTyped(json, false);
}

export function CountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Country {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

  export function CountryToJSON(json: any): Country {
      return CountryToJSONTyped(json, false);
  }

  export function CountryToJSONTyped(value?: Omit<Country, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
    };
}

